<template>
    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M130.001-90v-252.692h120v-160h207.307v-114.616h-120v-252.691h285.384v252.691h-120v114.616h207.307v160h120v252.691H544.616v-252.691h120v-114.616H295.384v114.616h120v252.691H130.001Z"/></svg>
</template>
